import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceSettingsNavigationMemberFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'fullName' | 'idEnterprise' | 'idEnterprisesAdmin' | 'idEnterprisesImplicitAdmin' | 'idPremOrgsAdmin' | 'memberType' | 'username'>
);

export const WorkspaceSettingsNavigationMemberFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceSettingsNavigationMember' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idEnterprise' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idEnterprisesAdmin' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idEnterprisesImplicitAdmin' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'idPremOrgsAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memberType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceSettingsNavigationMemberFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceSettingsNavigationMemberFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceSettingsNavigationMemberFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceSettingsNavigationMemberFragment>,
    'data'
  > {
  data?: WorkspaceSettingsNavigationMemberFragment;
}

export const useWorkspaceSettingsNavigationMemberFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceSettingsNavigationMemberFragmentOptions): UseWorkspaceSettingsNavigationMemberFragmentResult => {
  const result = Apollo.useFragment<WorkspaceSettingsNavigationMemberFragment>({
    ...options,
    fragment: WorkspaceSettingsNavigationMemberFragmentDoc,
    fragmentName: 'WorkspaceSettingsNavigationMember',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as WorkspaceSettingsNavigationMemberFragment,
  };
};
